import React from 'react';
import "./styles.css";
import { Loader } from '../components/profile';
import { fetchData, generateUUID, SmartImageComponent } from '../components/misc';
import { trackEvent } from '../utils/bridge.js';
import { useNavigate, Link } from 'react-router-dom';

const text="Hello Expats Elite Singles. I'm interested in your service. Kindly advise on how to proceed.".split(' ').join('%20')
const whatsapp = "https://api.whatsapp.com/send/?phone=+447456722140&text="+text+"+&type=phone_number";

const imageobjectcss = {
    width: "100%",
    height: "100%",
    objectFit: "cover"
}

const Banner = ({ images, linkitems, isempty }) => {
    const navigate = useNavigate()
    const [startIndex, setStartIndex] = React.useState(0)

    React.useEffect(() => {
        setStartIndex(0)
    }, [linkitems, isempty])

    React.useEffect(() => {
        if (isempty || linkitems.length === 0) {
            return
        }

        const intervalId = setInterval(() => {
            setStartIndex((previousIndex) => {
                if (linkitems.length === 0) {
                    return 0
                }

                return (previousIndex + 1) % linkitems.length
            })
        }, 5000)

        return () => clearInterval(intervalId)
    }, [linkitems, isempty])

    const gridItems = React.useMemo(() => {
        if (isempty) {
            return images.slice(0, 16)
        }

        if (linkitems.length === 0) {
            return []
        }

        const totalItems = Math.min(16, linkitems.length)
        const items = []

        for (let index = 0; index < totalItems; index += 1) {
            const currentIndex = (startIndex + index) % linkitems.length
            items.push(linkitems[currentIndex])
        }

        return items
    }, [images, isempty, linkitems, startIndex])

    function loginpleasefunction() {
        trackEvent('homepage_profiles_grid_clicked')
        navigate('/loginplease')
    }

    function isMdUp() {
        return window.matchMedia("(min-width: 768px)").matches;
    }


    function handleKeyDown(event) {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault()
            loginpleasefunction()
        }
    }

    const preventImageDownload = React.useCallback((event) => {
        event.preventDefault()
    }, [])

    if (isempty) {
        return (
            <div
                className={`w-11/12 mx-auto banner-grid cursor-pointer grid grid-cols-${isMdUp() ? "4" : 3} place-items-center justify-center`}
                onClick={() => trackEvent('homepage_empty_profiles_grid_clicked')}
                onKeyDown={handleKeyDown}
                role="button"
                tabIndex={0}
                aria-label="View member profiles"
            >
                    {gridItems.map(({ id, image }) => (
                        <div className="image" key={id}>
                            <img
                                src={image}
                                alt={""}
                                style={{ ...imageobjectcss, userSelect: 'none' }}
                                draggable={false}
                                onContextMenu={preventImageDownload}
                                onDragStart={preventImageDownload}
                                onMouseDown={preventImageDownload}
                                onTouchStart={preventImageDownload}
                            />
                        </div>
                    ))}
            </div>
          );
    } else {
        return (
              <div
                className={`w-11/12 mx-auto banner-grid cursor-pointer grid grid-cols-${isMdUp() ? "4" : 3} place-items-center justify-center`}
                onClick={loginpleasefunction}
                onKeyDown={handleKeyDown}
                role="button"
                tabIndex={0}
                aria-label="View member profiles"
              >
                    {gridItems.map(({ id, item }) => (
                        <div className="image" key={id}>
                            <SmartImageComponent
                                src={item.link}
                                id={id}
                                imageobjectcss={imageobjectcss}
                                cssclasses="w-auto h-full object-cover"
                                preventDownload
                            />
                        </div>
                    ))}
              </div>
          );
    }
};

export default function IndexPage() {
    const [loading, setLoading] = React.useState(true)
    const [empty, setIsEmpty] = React.useState(false)
    const [linkitems, setLinkItems] = React.useState([])

    React.useEffect(() => {
        const previousBackgroundImage = document.body.style.backgroundImage
        const previousBackgroundSize = document.body.style.backgroundSize
        const previousBackgroundRepeat = document.body.style.backgroundRepeat
        const previousBackgroundPosition = document.body.style.backgroundPosition
        const previousBackgroundAnimation = document.body.style.animation

        document.body.style.backgroundImage = "url('/assets/media/FORMBACKGROUND.jpeg')"
        document.body.style.backgroundSize = 'cover'
        document.body.style.backgroundRepeat = 'no-repeat'
        document.body.style.backgroundPosition = 'center'
        document.body.style.animation = 'none'

        return () => {
            document.body.style.backgroundImage = previousBackgroundImage
            document.body.style.backgroundSize = previousBackgroundSize
            document.body.style.backgroundRepeat = previousBackgroundRepeat
            document.body.style.backgroundPosition = previousBackgroundPosition
            document.body.style.animation = previousBackgroundAnimation
        }
    }, [])

    React.useEffect(function () {
        trackEvent('homepage_profiles_load_started')
        fetchData("/api/getmenfiles/index").then((data) => {
            trackEvent('homepage_profiles_load_success', { count: data.images.length })
            if (data.images.length !== 0) {
                setLinkItems(data.images.map((item) => ({
                    id: generateUUID(),
                    item
                })))
                setLoading(false)
            } else {
                var images = data.images.concat(data.images).concat(data.images)

                setLinkItems(images.concat(images).map((item) => ({
                    id: generateUUID(),
                    item
                })))
                setLoading(false)
                setIsEmpty(true)
            }
        }).catch((error) => {
            trackEvent('homepage_profiles_load_failed')
            console.error("Error fetching auth codes:", error);
            throw error;
        })
    }, [])

    const images = [
        "https://images.unsplash.com/photo-1502602898657-3e91760cbb34?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxleHBsb3JlLWZlZWR8Mnx8fGVufDB8fHx8&w=1000&q=80",
        "https://images.unsplash.com/photo-1499856871958-5b9627545d1a?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxleHBsb3JlLWZlZWR8MXx8fGVufDB8fHx8&w=1000&q=80",
        "https://media.istockphoto.com/photos/the-main-attraction-of-paris-and-all-of-europe-is-the-eiffel-tower-in-picture-id1185953092?k=6&m=1185953092&s=612x612&w=0&h=SNiShskOfwQ7Sys5TX0eb5eBxHobktWUfZGrox5LMyk=",
        "https://images.unsplash.com/photo-1541963463532-d68292c34b19?ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8Ym9va3xlbnwwfHwwfHw%3D&ixlib=rb-1.2.1&w=1000&q=80",
        "https://images.ctfassets.net/hrltx12pl8hq/3MbF54EhWUhsXunc5Keueb/60774fbbff86e6bf6776f1e17a8016b4/04-nature_721703848.jpg?fit=fill&w=480&h=270",
        "https://cdn.pixabay.com/photo/2015/04/23/22/00/tree-736885__480.jpg",
        "https://images.unsplash.com/photo-1503023345310-bd7c1de61c7d?ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8aHVtYW58ZW58MHx8MHx8&ixlib=rb-1.2.1&w=1000&q=80"
    ].map((image) => ({
    id: generateUUID(),
    image
    }));

    const hostname = typeof window !== 'undefined' ? window.location.hostname : ''
    const logoSrc = {
        'penzi-halisi.com': '/assets/img/phlogo.jpeg',
        'upendo-halisi.com': '/assets/img/uhlogo.jpeg'
    }[hostname] || '/assets/img/logo.jpeg'

    return (
        <div className="flex flex-col items-center w-full">
            <header id="main" className="flex flex-row justify-between mb-2 mt-0 w-full">
                <a href='/' onClick={() => trackEvent('homepage_logo_clicked')}>
                    <img className="img-fluid h-10 w-10" src={logoSrc} alt="HalaalLove logo"/>
                </a>
            </header>

            <main className="flex flex-row justify-center mx-6 overflow-x-hidden mb-2 w-full">
                <Link className="w-1/2 py-2 m-1 px-4 bg-gradient-to-r from-indigo-400 to-cyan-400 text-black text-xs text-center md:text-xl font-bold flex items-center justify-center" to="/html/authcode.html" onClick={() => trackEvent('homepage_signup_clicked')}>
                    <p>SIGNUP</p>
                </Link>
                {/* <a className="w-1/3 py-2 m-1 px-4 bg-gradient-to-r from-teal-400 to-gray-800 text-white text-xs text-center md:text-xl font-bold flex flex-col items-center justify-center" href={whatsapp} onClick={() => trackEvent('homepage_whatsapp_clicked')}>
                    <i className="fa-brands fa-whatsapp"></i>
                    <p className="mt-1">TALK TO US</p>
                </a> */}
                <Link className="w-1/2 py-2 m-1 px-4 bg-gradient-to-r from-red-500 to-orange-500 text-white text-xs text-center md:text-xl font-bold flex items-center justify-center" to="/login" onClick={() => trackEvent('homepage_login_clicked')}>
                    <p>LOGIN</p>
                </Link>
            </main>

            <div className="App mx-10 overflow-x-hidden w-full">
                {loading
                    ? <Loader/>
                    : <Banner images={images} linkitems={linkitems} isempty={empty} />
                }
            </div>

            {/* <div className="m-2 flex flex-row items-center justify-center md:px-10 w-full overflow-x-hidden">
                <Link className="w-1/4 p-3 m-2 h-32 w-full bg-gradient-to-r from-purple-500 to-purple-900 text-white text-sm md:text-xl font-bold text-center flex items-center justify-center" to="/howitworks">
                    <p>HOW<br/>IT<br/>WORKS</p>
                </Link>
                <Link className="w-1/4 p-3 m-2 h-32 w-full bg-gradient-to-r from-indigo-400 to-cyan-400 text-white text-sm md:text-xl font-bold text-center flex items-center justify-center" to="/alltestimonials">
                    <p>REVIEWS</p>
                </Link>
                <Link className="w-1/4 p-3 m-2 h-32 w-full bg-gradient-to-r from-blue-800 to-indigo-900 text-white text-sm md:text-xl font-bold text-center flex items-center justify-center" to="/faq">
                    <p>FAQ'S</p>
                </Link>
            </div> */}

            <footer id="footer" className="m-2 overflow-x-hidden w-full">
                <p className="w-full text-xs text-white font-normal text-center mb-1">
                    <Link className="underline" to="/privacypolicy" onClick={() => trackEvent('homepage_privacy_policy_clicked')}>Privacy Policy</Link>
                </p>
                <p className="w-full text-xs uppercase text-white font-normal text-center">Copyright © 2017</p>
            </footer>
        </div>
    )
}
